import { UNITS } from "../../constants/constants"

export const volumeWeight = (height: string, width: string, length: string, unit: string): number => {
    const divider = unit === UNITS["1"]?.WEIGHT ? 139 : 5000

    return (parseFloat(height) * parseFloat(length) * parseFloat(width)) / divider
}

const ChargeableWeight = (VolumeWeight: number, actualWeight: number): number => {
    if (VolumeWeight <= actualWeight) VolumeWeight = actualWeight
    return VolumeWeight
}

export default ChargeableWeight
